// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("jquery");
global.$ = global.jQuery = jQuery;
window.$ = window.jQuery = jQuery;

require("@rails/activestorage").start();
require("channels");
require("select2");
require("lodash");
require("@nathanvda/cocoon");
require("query-string");

require("external_libs/jquery-ui.custom.min");
require("packs/index");
require("packs/workloads");
require("packs/construction");
require("packs/estimate");
require("packs/team");
require("packs/team_management");
require("packs/worker_charge");
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
